/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedStudentEnrollments200,
  GetApiV1PersonSharedStudentEnrollments401,
  GetApiV1PersonSharedStudentEnrollments500,
  GetApiV1PersonSharedStudentEnrollmentsQueryParams,
  GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedStudentEnrollments.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1PersonSharedStudentEnrollmentsQueryParamsSchema = z.object(
  {
    filter: z.optional(z.string()),
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(20),
  },
) as unknown as ToZod<GetApiV1PersonSharedStudentEnrollmentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedStudentEnrollments200Schema = z.array(
  z.lazy(() => dropDownListStringKeyViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedStudentEnrollments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedStudentEnrollments401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedStudentEnrollments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedStudentEnrollments500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedStudentEnrollments500>;

export const getApiV1PersonSharedStudentEnrollmentsQueryResponseSchema = z.lazy(
  () => getApiV1PersonSharedStudentEnrollments200Schema,
) as unknown as ToZod<GetApiV1PersonSharedStudentEnrollmentsQueryResponse>;
